import React from "react";
import Link from "next/link";

export default function TrustedBy({ lang = 'vn' }: { lang?: 'vn' | 'en' }) {
  return (
    <>
<div className="section_trusted" style={{ background: "linear-gradient(180deg, #030014 0%, #080718 100%)", color: "#ffffff", padding: "80px 0", marginTop: "0" }}>
 <div className="container-small less-padding-top">
  <section className="slider-section-main-banner-2 padding-top">
   <div className="w-layout-blockcontainer hom-banner-container-2 w-container">
    <div className="marquee-content-wrapper" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
     <div className="text-size-large" style={{ marginBottom: '40px', textAlign: 'center', opacity: 0.8, width: '100%' }}>
      {lang === 'vn' ? 'Được tin dùng bởi' : 'Trusted by'}
     </div>
     <div className="marquee-wrapper">
      <div className="logos-wrapper">
       <img alt="" className="logo-icon" loading="lazy" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9aff7_635989ab5c73854b6a7035cf_logo-cadc%402x%402x.avif"/>
       <img alt="" className="logo-icon" loading="lazy" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9b003_Cambridge-maryland.avif"/>
       <img alt="" className="logo-icon f" loading="lazy" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68ae19b639ee9b64a6abfb61_3%20(2).avif"/>
       <img alt="" className="logo-icon" loading="lazy" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9b001_splash-car-wash.avif"/>
       <img alt="" className="logo-icon" loading="lazy" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9b01d_spark-car-wash.avif"/>
       <img alt="" className="logo-icon" loading="lazy" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9b01f_ruggable.avif"/>
       <img alt="" className="logo-icon" loading="lazy" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68ae19dc6eaa0a9a7fbdb619_7%20(1).avif"/>
      </div>
      <div className="left-gradient">
      </div>
      <div className="right-gradient">
      </div>
     </div>
    </div>
   </div>
  </section>
  <div 
    className="quote-wrapper no-neg-margin" 
    data-w-id="b120c54e-c4d8-cd80-948c-73a6cbb1f7a8"
    style={{
      background: "rgba(255, 255, 255, 0.02)",
      backdropFilter: "blur(20px)",
      WebkitBackdropFilter: "blur(20px)",
      border: "1px solid rgba(255, 255, 255, 0.06)",
      borderRadius: "24px",
      padding: "50px 36px",
      boxShadow: "0 20px 50px rgba(0,0,0,0.4)",
      marginTop: "48px",
      maxWidth: "960px",
      marginLeft: "auto",
      marginRight: "auto",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    }}
  >
   <h2 className="heading-style-h3-4 light mb-16" style={{
     fontSize: "32px",
     fontWeight: "800",
     letterSpacing: "-1px",
     background: "linear-gradient(135deg, #ffffff 0%, #c7d2fe 100%)",
     WebkitBackgroundClip: "text",
     WebkitTextFillColor: "transparent",
     backgroundImage: "linear-gradient(135deg, #ffffff 0%, #c7d2fe 100%)",
     textAlign: "center",
     marginBottom: "16px",
     lineHeight: "1.25"
   }}>
     {lang === 'vn' ? 'Hệ thống Camera của bạn phải làm việc hiệu quả như Đội ngũ của bạn' : 'Your Cameras Should Work As Hard As Your Team'}
   </h2>
   <p className="subss light text-align-center" style={{
     fontSize: "15px",
     lineHeight: "1.65",
     color: "rgba(255, 255, 255, 0.8)",
     maxWidth: "760px",
     marginLeft: "auto",
     marginRight: "auto",
     textAlign: "center",
     margin: 0
   }}>
     {lang === 'vn' 
       ? 'Triển khai các AI Agents giúp chuẩn hóa vận hành, đào tạo đội ngũ và thực thi các hành động theo thời gian thực 24/7. Từ ngăn chặn an ninh trực tiếp đến tối ưu hóa sản xuất — nhận được sự tin cậy như nhân viên giỏi nhất của bạn, mở rộng trên mọi ca làm việc.'
       : 'Deploy AI agents that standardize your operations, coach your team, and execute real-time actions 24/7. From live security deterrence to manufacturing optimization — get the reliability of your best employee, scaled across every shift.'}
   </p>
  </div>
 </div>
</div>

    </>
  );
}
